import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/core/data-fetching/queryKeys';
import { migrationService, type MigrationLegacyClientsListParams } from '../api/migration.service';

export function useMigrationLegacyClientsQuery(params: MigrationLegacyClientsListParams) {
  const page = params.page ?? 1;
  const limit = params.limit ?? 20;
  const search = params.search?.trim() || undefined;

  return useQuery({
    queryKey: queryKeys.migration.legacyClients({ page, limit, search }),
    queryFn: () => migrationService.listLegacyClients({ page, limit, search }),
    placeholderData: keepPreviousData,
  });
}
